module.exports = __webpack_public_path__ + "static/media/Marshtomp_gaussian2.cf69511b.png";